import blocking from '../api/blocking'

export default {
  state: {
    blocking:[],
    activeAffiliates:[],
    trafficPaymentsByAffiliate:[]
  },
  namespaced: true,
  mutations: {
    async saveBlocking(state, blocking) {
      state.blocking = blocking
    },
    async addBlocking(state, blocking) {
      state.blocking.count += 1
      state.blocking.data.push(blocking)
    },
    async delBlocking(state, {id}) {
      state.blocking.count -= 1
      state.blocking.data = state.blocking.data.filter(i=>(i.id !== id))
    },
    async getActiveAffiliates(state, affiliates) {
      state.activeAffiliates = affiliates
    },
    async getTrafficPaymentsByAffiliate(state, trafficPaymentsByAffiliate) {
      state.trafficPaymentsByAffiliate = trafficPaymentsByAffiliate
    },
  },
  actions: {
    async saveBlockingStore ({ commit }, payload) {
      commit('saveBlocking', await blocking.blocking(payload))
    },
    async addBlockingStore({commit}, data) {
      try {
        const resp = await blocking.addBlocking(data)
        commit('addBlocking',data);
        return resp;
      } catch (e) {
        console.error('addBlocking Error:',e)
      }
    },
    async delBlockingStore({commit}, data) {
      try {
        const resp = await blocking.delBlocking(data)
        commit('delBlocking',data);
        return resp;
      } catch (e) {
        console.error('delBlocking Error:',e)
      }
    },

    async getActiveAffiliatesStore({commit}, data) {
      try {
        const resp = await blocking.getActiveAffiliates(data)
        commit('getActiveAffiliates',resp);
        return resp;
      } catch (e) {
        console.error('getActiveAffiliates Error:',e)
      }
    },

    async getTrafficPaymentsByAffiliateStore({commit}, data) {
      try {
        const resp = await blocking.getTrafficPaymentsByAffiliate(data)
        commit('getTrafficPaymentsByAffiliate',resp);
        return resp;
      } catch (e) {
        console.error('getTrafficPaymentsByAffiliate Error:',e)
      }
    },

  },
  getters: {
    getBlocking: state => state.blocking,
    getActiveAffiliates: state => state.activeAffiliates,
    getTrafficPaymentsData: state => state.trafficPaymentsByAffiliate,
  },

}
